import React from "react";
import { ServerErrorPage } from "../fallback/fallbackPage";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by boundary:", error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
    // If a chunk failed to load (typically due to a stale client cache or
    // service worker serving an old asset manifest), attempt to recover by
    // unregistering service workers, clearing caches, and reloading.
    try {
      const message = error && (error.message || "");
      const isChunkError = (error && error.name === "ChunkLoadError") || /Loading chunk .* failed/.test(message) || /loading chunk/i.test(message);
      if (isChunkError && typeof window !== "undefined") {
        // Attempt best-effort cleanup then reload
        const cleanupAndReload = async () => {
          try {
            if (navigator && navigator.serviceWorker && navigator.serviceWorker.getRegistrations) {
              const regs = await navigator.serviceWorker.getRegistrations();
              await Promise.all(regs.map((r) => r.unregister()));
            }
            if (window.caches && caches.keys) {
              const keys = await caches.keys();
              await Promise.all(keys.map((k) => caches.delete(k)));
            }
          } catch (e) {
            // ignore errors during cleanup
            // eslint-disable-next-line no-console
            console.warn("Error during service-worker/cache cleanup:", e);
          } finally {
            window.location.reload(true);
          }
        };
        // Delay slightly to allow the error UI to render, then reload.
        setTimeout(cleanupAndReload, 800);
      }
    } catch (e) {
      // ignore
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <ServerErrorPage
          onRetry={this.handleRetry}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
